import { useMemo, useState } from 'react';
import { lang } from '../../Utils';
import Item from './features/Item';
import { Button } from '../../components/button/Button';
import { PencilSquare, Check2Square} from 'react-bootstrap-icons';
import { getConfiguration, saveConfiguration } from './Services';
import { Icon } from '@chakra-ui/react';

function Index({ attributes }) {

  const [isEdit, setIsEdit] = useState();
  const [currentGroup, setCurrentGroup] = useState('all');
  const [configuration, setConfiguration] = useState({});
  const [userCountry, setUserCountry] = useState();

  const settings = JSON.parse(attributes.settings.replace(/'/g, '"'));
  const groups = Array.from(new Set([...Object.entries(settings).map(value => value[1].group)]));

  const handleSave = () => {
    saveConfiguration(configuration)
      .then(_ => setIsEdit(false));
  }

  const handleCheck = (check, uuid) => {
    setConfiguration((prevState) => ({...prevState, [uuid]: check}));
  }

  useMemo(() => {
    getConfiguration()
      .then(data =>  {
        let values = Object.entries(settings)
          .reduce((configuration, setting) => configuration = {...configuration, [setting[0]] : (data.configuration[setting[0]] !== undefined) ? data.configuration[setting[0]] : true}, {})
        setConfiguration(values);
        setUserCountry(data.country)
      });
  }, [attributes.api])

  return (
    <div className="my-homepage-section">
      <div className="my-homepage-header">
        <div className="my-homepage-actions">
          {(isEdit) ?
            <Button onClick={() => handleSave()}><PencilSquare /><span>{lang('Save')}</span></Button> :
            <Button onClick={() => setIsEdit(true)}><Check2Square /><span>{lang('Edit')}</span></Button>
          }
        </div>
        {(isEdit) ?
          <div className="my-homepage-tabs">
            <div className={`my-homepage-tab ${(currentGroup === 'all') ? 'active' : ''}`} onClick={() => setCurrentGroup('all')}>{lang('All')}</div>
            {groups.map(value => <div onClick={() => setCurrentGroup(value)} className={`my-homepage-tab ${(currentGroup === value) ? 'active' : ''}`}>{value}</div>)}
          </div>
          : null}
      </div>
      <div className={`my-homepage-items ${(isEdit) ? 'edit-mode' : ''}`}>
        {Object.entries(settings)
          .filter(item => (isEdit || configuration[item[0]]) && (item[1].roles === undefined || item[1].roles.length == 0 || item[1].roles.indexOf(attributes.role) > -1))
          .map(item => <Item {...item[1]} country={userCountry} lang={lang} value={configuration[item[0]]} uuid={item[0]} currentGroup={currentGroup} isEdit={isEdit} handleCheck={handleCheck}/>)}
      </div>
    </div>
  );
}

export {Index};
